<template>
  <div class="modal-toast col-block" :class="param.type">
    <div class="content" v-html="param.content"></div>
    <template v-if="param.confirm">
      <div :style="{ height: '10px' }"></div>
      <div class="toast-confirm input-group">
        <input type="text" :placeholder="param.confirm.placeholder" v-model="confirm">
      </div>
    </template>
    <div :style="{ height: '20px' }"></div>
    <div class="button-row row-block">
      <div :style="{ flex: 1 }"></div>
      <button v-for="(button, index) in param.buttons || []" :key="index" :class="[button.type + '-button', 'circle-button']" :disabled="button.result && (param.confirm || {}).value && ((param.confirm || {}).value !== confirm)" @click="$emit('changeModal', {}, button.result)">
        <span>{{ button.title }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      confirm: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/toast.vue